import isEqual from "lodash.isequal";
import { useState } from "#app";
import { ref } from "vue";
function getStateWithoutPage(state) {
  const { page, ...rest } = state || {};
  return rest;
}
const KEY = "ais.infiniteHits";
function getKeyFromState(state, key) {
  return `${key ?? KEY}`;
}
const _storage = () => import.meta.server ? ref({}) : useState("_instantsearchStorageState", () => ({}));
export const useAisInfiniteHitsStatefulCache = (key) => {
  const ssrPage = useState(`${key ?? KEY}-server-page`, () => 0);
  const sessionStorage = {
    getItem(key2) {
      return _storage().value[key2];
    },
    setItem(key2, value) {
      return _storage().value[key2] = value;
    },
    removeItem(key2) {
      if (_storage().value?.[key2]) delete _storage().value[key2];
    }
  };
  const cache = {
    read: ({ state }) => {
      try {
        const cache2 = sessionStorage.getItem(getKeyFromState(state, key));
        const maxPage = Math.max(ssrPage.value, state.page ?? 0);
        return cache2 && isEqual(cache2.state, getStateWithoutPage(state)) ? Object.fromEntries(
          Object.entries(cache2.hits).slice(0, maxPage)
        ) : null;
      } catch (error) {
        console.error(error);
        if (error instanceof SyntaxError) {
          try {
            sessionStorage.removeItem(KEY);
          } catch (err) {
          }
        }
        return null;
      }
    },
    write: ({ state, hits }) => {
      if (import.meta.server) ssrPage.value = state.page;
      try {
        const currentHits = sessionStorage.getItem(getKeyFromState(state, key))?.hits ?? {};
        const hitsToWrite = { ...currentHits, ...hits };
        sessionStorage.setItem(getKeyFromState(state, key), {
          state: getStateWithoutPage(state),
          hits: hitsToWrite
        });
      } catch (error) {
        console.error(error);
      }
    }
  };
  return cache;
};
